<template>
    <div>
        <validation-observer ref="signatureForm">
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
            <div  :class="{isPopUp, 'signature-attribute' : ''}">
                <validation-provider :rules="question.mandatory ? 'required' : ''" v-slot="{errors}">
                    <label :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}" v-if="isInquiry">
                        {{ question.question_text }}
                    </label>
                <div :class="{' col-md-9 col-xs-8' : isInquiry}" :id="accordionId"  ref="accordion" role="tablist" aria-multiselectable="true">
                    <img v-if = "url" :src="url" width="140px" class="image-bigpic">
                    <img v-else  :src="replacedText" width="140px" class="image-bigpic">
                    <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                    <div class="card">
                        <div class="card-header" role="tab" id="section1HeaderId">
                            <div class="btn-group" role="group">
                                <button type="button" class="collapseButton btn-new-primary btn" data-toggle="collapse" data-parent="#accordianId" :href="`#${sectionId}`"
                                        aria-expanded="false" aria-controls="section1ContentId">
                                    {{ question.question_text }}
                                </button>
                            </div>
                        </div>
                        <div :id="sectionId" class="collapseDiv collapse" role="tabpanel" aria-labelledby="section1HeaderId">
                            <div class="card-body">
                                <div class="row">
                                    <div :class="{'col-md-12 col-md-offset-4' : true , 'm-top-10 m-bottom-10 col-md-offset-0 sign-canvas':isInquiry} ">
                                        <input  v-if = "url" :id="id" type="hidden" :name="name" :value="url" >
                                        <input  v-else :id="id" type="hidden" :name="name" :value="replacedText" >
                                        <canvas
                                            ref="canvas"
                                            class="signature-canvas width_border_border-radius "
                                            @click="removePlaceholder">
                                            <img :src="dataSubmit[`question_${question.update_booking_question_id}_0`]" v-if="question && dataSubmit && dataSubmit[`question_${question.update_booking_question_id}_0`]">
                                        </canvas>
                                        <input type="hidden" value="signature" :name="questionType">
                                    </div>
                                    <div class="col-md-12 text-center" v-if="captured">
                                        <div class="alert alert-success"> captured successfully </div>
                                    </div>
                                </div>
                                <div class="btn-toolbar" role="toolbar" v-if="isLoading"><img src="/pic/loading-4.gif"></div>
                                <div class="btn-toolbar" role="toolbar" v-else>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-primary" @click="updateSignature">Update
                                            Signature
                                        </button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" @click="clearSignature">Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                    </div>
                </div>
                </validation-provider>
                <input type="hidden" :value="name" name="questions[]">
            </div>
        </div>
        </validation-observer>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import Api from '../../api/index.js';
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormSignature",
    props: {
        value: {
            type: Object,
            default() {
                return {}
            },
        },
        isPopUp:false,
        dataSubmit: {
            type: Object,
            default() {
                return {}
            }
        },
        constrains: null,
        customerId: null,
        s3Path:{

            default() {
                return '';
            }
        },
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    // props: ["question", "dataSubmit", "validationErrors", "constrains", "customerId"],
    data() {
        return {
            question: this.value,
            image: null,
            canvas: null,
            context: null,
            captured: false,
            url: null,
            isLoading: false,
            replacementText: null,
        }
    },
    computed: {
        accordionId() {
            return `accordion_attribute_${this.question.update_booking_question_id}_0`;
        },
        sectionId() {
            return `section_${this.question.update_booking_question_id}_0`;
        },
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`
        },
        id() {
            return `signature_value_input_question_${this.question.update_booking_question_id}_0`
        },
        questionType() {
            return `question_type_${this.question.update_booking_question_id}`
        },
        replacedText() {
            // Use the replace method with a regular expression to replace the substring
            if(this.question.answer_text){
                let link  = this.question.answer_text.replace(
                    this.s3Path+this.s3Path,
                    this.s3Path
                );
                this.question.value = link;
                return link;
            }
        },
    },
    methods: {
        setCanvasSettings() {
            this.canvas = this.$refs['canvas'];
            if(this.canvas){
                this.context = this.canvas.getContext("2d");
                new SignaturePad(this.canvas);
            }

        },
        removePlaceholder() {
            this.canvas.classList.remove('signature-canvas')
        },
        resetSignature(){
            this.captured = false;
            this.image = null;
            this.url = null;
            this.isLoading = true;
            // this.dataSubmit[`question_${this.question.update_booking_question_id}`] = null;
        },
        updateSignature() {
                // alert('here');
            //reset values
            this.resetSignature();

            this.image = this.canvas.toDataURL("image/png", 1.0);
            // alert(this.image )
            // alert( this.question.update_booking_question_id);
            Api.uploadSignature({
                image: this.image,
                customer_id: 2,
                attribute_id: this.question.update_booking_question_id,
            }).then(response => {
                if (response.data.status == "success"){
                    this.captured = true;
                    this.url = response.data.result;
                    this.question.value = response.data.result;
                    this.dataSubmit[`question_${this.question.update_booking_question_id}_0`] = this.url;
                    this.isLoading = false;

                    if(this.viewPage && this.isInquiry){
                        updateFormQuestionOnViewInquiry( response.data.result, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
                    }
                }
            })
        },
        getBucketLink(){
            Api.getBucketLink().then(response => {
                if (response.data.status == "success"){
                    this.replacementText = response.data.link;
                }
            })
        },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.signatureForm) {
                    let validated = await this.$refs.signatureForm.validate();
                    verify(validated)
                }
            })
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },

        clearSignature() {
            //reset values
            this.resetSignature();

            // noinspection JSUnresolvedFunction
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.canvas.classList.add('signature-canvas');
            this.isLoading = false;
        }
    },
    mounted() {
        this.addEventListeners()
        let vm = this;
        this.setCanvasSettings();
        this.getBucketLink();
        EventBus.$on('resetSignature', function (value) {
            let src = vm.dataSubmit[`question_${vm.question.update_booking_question_id}_0`];
            vm.clearSignature();
            $(".collapseButton").addClass('collapsed');
            $(".collapseDiv").removeClass('in').css('height', '0px');
            vm.dataSubmit[`question_${vm.question.update_booking_question_id}_0`] = src;
            if (! value){
                let img = new Image();
                img.onload = function(){
                    vm.canvas.width = img.width;
                    vm.canvas.height = img.height;
                    vm.context.drawImage(img, 0, 0, img.width, img.height);
                }
                img.src = src;
            }
        });
    },
    watch:{
        dataSubmit(value){
            if (value){
                EventBus.$emit('resetSignature', false);
            }

        }
    },
    destroyed() {
        this.removeEventListeners();
    }
}
</script>

<style scoped>

.width_border_border-radius{
    border: 1px solid #000000;
    border-radius: 5px;

}
.canvas-control {
    width: 100%;
    min-height: 300px;
}

.signature-canvas {
    background-image: url('/pic/sign-here.png');
    background-repeat: no-repeat;
    background-position: center;
}
.signature-attribute{
    margin: 0px -13px 19px;
}


</style>